import React from 'react';
import ProfileLayout from '../../components/ProfileLayout';
import SocialContent from '../../components/SocialContent';

const SocialPage = () => {
  return (
    <ProfileLayout activeItem="social">
      <SocialContent />
    </ProfileLayout>
  );
};

export default SocialPage;
